import { render, staticRenderFns } from "./OutpatientReviewDemographics.vue?vue&type=template&id=4afdbaea&"
import script from "./OutpatientReviewDemographics.vue?vue&type=script&lang=js&"
export * from "./OutpatientReviewDemographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports